require("./bootstrap")
import mixin from "./components/mixin.js";

const app = new Vue({
	el: '#app',
	mixins: [mixin],
	data: {
		takeawayBoxQty: 0,
		takeawayBoxDefaultQty: 0,
		takeawayBoxPrice: 0,
		takeawayPlasticBagQty: 0,
		takeawayPlasticBagDefaultQty: 0,
		takeawayPlasticBagPrice: 0,
		takeawayDiningUtensilQty: 0,
		takeawayDiningUtensilDefaultQty: 0,
		takeawayDiningUtensilPrice: 0,
		takeawayData: (typeof takeawayData !== "undefined") ? takeawayData : null,
		takeawayBoxId: 0,
		takeawayPlasticBagId: 0,
		takeawayDiningUtensilId: 0,
		takeawayBoxCartQty: 0,
		takeawayPlasticBagCartQty: 0,
		takeawayDiningUtensilCartQty: 0,
		// raw id
		takeawayBoxCartRawId: null,
		takeawayPlasticBagRawId: null,
		takeawayDiningUtensilRawId: null,
	},
	created: function () {
		if (document.getElementById('takeawayBoxId')) {
			this.takeawayBoxQty = parseInt(document.getElementById('takeawayBoxQty').value);
			this.takeawayBoxDefaultQty = this.takeawayBoxQty;
			this.takeawayBoxPrice = document.getElementById('takeawayBoxPrice').value;
			this.takeawayBoxId = document.getElementById('takeawayBoxId').value;
			this.takeawayBoxCartRawId = document.getElementById('takeawayBoxCartRawId').value;
			this.takeawayBoxCartQty = parseInt(document.getElementById('takeawayBoxCartQty').value);
		}

		if (document.getElementById('takeawayPlasticBagId')) {
			this.takeawayPlasticBagQty = parseInt(document.getElementById('takeawayPlasticBagQty').value);
			this.takeawayPlasticBagDefaultQty = this.takeawayPlasticBagQty;
			this.takeawayPlasticBagPrice = document.getElementById('takeawayPlasticBagPrice').value;
			this.takeawayPlasticBagId = document.getElementById('takeawayPlasticBagId').value;
			this.takeawayPlasticBagRawId = document.getElementById('takeawayPlasticBagCartRawId').value;
			this.takeawayPlasticBagCartQty = parseInt(document.getElementById('takeawayPlasticBagCartQty').value);
		}

		if (document.getElementById('takeawayDiningUtensilId')) {
			this.takeawayDiningUtensilQty = parseInt(document.getElementById('takeawayDiningUtensilQty').value);
			this.takeawayDiningUtensilDefaultQty = this.takeawayDiningUtensilQty;
			this.takeawayDiningUtensilPrice = document.getElementById('takeawayDiningUtensilPrice').value;
			this.takeawayDiningUtensilId = document.getElementById('takeawayDiningUtensilId').value;
			this.takeawayDiningUtensilRawId = document.getElementById('takeawayDiningUtensilCartRawId').value;
			this.takeawayDiningUtensilCartQty = parseInt(document.getElementById('takeawayDiningUtensilCartQty').value);
		}
		
		if (this.takeawayBoxCartQty > 0 && this.takeawayBoxCartQty > this.takeawayBoxQty) {
			this.takeawayBoxQty = this.takeawayBoxCartQty;
		}
		if (this.takeawayPlasticBagCartQty > 0 && this.takeawayPlasticBagCartQty > this.takeawayPlasticBagQty) {
			this.takeawayPlasticBagQty = this.takeawayPlasticBagCartQty;
		}
		if (this.takeawayDiningUtensilCartQty > 0 && this.takeawayDiningUtensilCartQty > this.takeawayDiningUtensilQty) {
			this.takeawayDiningUtensilQty = this.takeawayDiningUtensilCartQty;
		}
	},
	mounted() {
	},
	watch: {
		takeawayPlasticBagQty() {
			this.takeawayPlasticBagQty = this.takeawayPlasticBagQty > 0 ? this.takeawayPlasticBagQty : 0
		},
		takeawayBoxQty() {
			this.takeawayBoxQty = this.takeawayBoxQty > 0 ? this.takeawayBoxQty : 0
		},
		takeawayDiningUtensilQty() {
			this.takeawayDiningUtensilQty = this.takeawayDiningUtensilQty > 0 ? this.takeawayDiningUtensilQty : 0
		},
		// get cart latest suggest qty (always use latest cart suggestted qty to replace cart qty)
		latestCartDefaultBoxQty() {
			// this.takeawayBoxQty = this.latestCartDefaultBoxQty > this.takeawayBoxQty ? this.latestCartDefaultBoxQty : this.takeawayBoxQty;
			this.takeawayBoxQty = this.latestCartDefaultBoxQty;
			this.takeawayBoxDefaultQty = this.latestCartDefaultBoxQty;
		},
		latestCartDefaultPlasticBagQty() {
			// this.takeawayPlasticBagQty = this.latestCartDefaultPlasticBagQty > this.takeawayPlasticBagQty ? this.latestCartDefaultPlasticBagQty : this.takeawayPlasticBagQty;
			this.takeawayPlasticBagQty = this.latestCartDefaultPlasticBagQty;
			this.takeawayPlasticBagDefaultQty = this.latestCartDefaultPlasticBagQty;
		},
		latestCartDefaultDiningUtensilQty() {
			// this.takeawayDiningUtensilQty = this.latestCartDefaultDiningUtensilQty > this.takeawayDiningUtensilQty ? this.latestCartDefaultDiningUtensilQty : this.takeawayDiningUtensilQty;
			this.takeawayDiningUtensilQty = this.latestCartDefaultDiningUtensilQty;
			this.takeawayDiningUtensilDefaultQty = this.latestCartDefaultDiningUtensilQty;
		}
	},
	computed: {
		cartTotalWithTakeaway() {
			return this.getTotalAmount().cartOrigTotal + this.takeawayDiningUtensilPrice * this.takeawayDiningUtensilQty + this.takeawayPlasticBagPrice * this.takeawayPlasticBagQty + this.takeawayBoxPrice * this.takeawayBoxQty;
		},
		cartRetailTotalWithTakeaway() {
			return this.getTotalAmount().cartRetailTotal + this.takeawayDiningUtensilPrice * this.takeawayDiningUtensilQty + this.takeawayPlasticBagPrice * this.takeawayPlasticBagQty + this.takeawayBoxPrice * this.takeawayBoxQty;
		}
	},
	methods: {
		async goToDelivery() {
			if (!$.isEmptyObject(this.cart)) {
				await this.addExtraItemToCart();
				window.location.href = "/ordering/checkout/pickup";
			}
		},
		async addExtraItemToCart() {
			try {
				this.loading = true;
				if ((this.takeawayBoxQty - this.takeawayBoxCartQty) > 0) {
				// increase qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.productId = this.takeawayBoxId;
					this.info.qty = this.takeawayBoxQty - this.takeawayBoxCartQty;
					this.info.category = "";

					const { data } = await this.api(
						"/ordering/cart",
						"post",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if ((this.takeawayBoxQty - this.takeawayBoxCartQty) < 0 && this.takeawayBoxQty != 0) {
				// reduce qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.qty = Math.abs(this.takeawayBoxQty - this.takeawayBoxCartQty);
					const { data } = await this.api(
						"/ordering/cart/" + this.takeawayBoxCartRawId,
						"put",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if (this.takeawayBoxQty == 0 && this.takeawayBoxCartQty > 0) {
				// remove from cart
					const result = await this.api(`/ordering/cart/${this.takeawayBoxCartRawId}`, 'delete', null);
				}

				if ((this.takeawayPlasticBagQty - this.takeawayPlasticBagCartQty) > 0) {
				// increase qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.productId = this.takeawayPlasticBagId;
					this.info.qty = this.takeawayPlasticBagQty - this.takeawayPlasticBagCartQty;
					this.info.category = "";

					const { data } = await this.api(
						"/ordering/cart",
						"post",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if ((this.takeawayPlasticBagQty - this.takeawayPlasticBagCartQty) < 0 && this.takeawayPlasticBagQty != 0) {
				// reduce qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.qty = Math.abs(this.takeawayPlasticBagQty - this.takeawayPlasticBagCartQty);
					const { data } = await this.api(
						"/ordering/cart/" + this.takeawayPlasticBagRawId,
						"put",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if (this.takeawayPlasticBagQty == 0 && this.takeawayPlasticBagCartQty > 0) {
				// remove from cart
					const result = await this.api(`/ordering/cart/${this.takeawayPlasticBagRawId}`, 'delete', null);
				}

				if ((this.takeawayDiningUtensilQty - this.takeawayDiningUtensilCartQty) > 0) {
				// increase qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.productId = this.takeawayDiningUtensilId;
					this.info.qty = this.takeawayDiningUtensilQty - this.takeawayDiningUtensilCartQty;
					this.info.category = "";

					const { data } = await this.api(
						"/ordering/cart",
						"post",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if ((this.takeawayDiningUtensilQty - this.takeawayDiningUtensilCartQty) < 0 && this.takeawayDiningUtensilQty != 0) {
				// reduce qty
					this.info = {};
					this.info.isExtraTakeawayItem = true;
					this.info.qty = Math.abs(this.takeawayDiningUtensilQty - this.takeawayDiningUtensilCartQty);
					const { data } = await this.api(
						"/ordering/cart/" + this.takeawayDiningUtensilRawId,
						"put",
						this.info
					);
					if (data) {

					} else {
						this.connectionErrorHanding(status);
						console.log("Error message: Data missing");
					}
				} else if (this.takeawayDiningUtensilQty == 0 && this.takeawayDiningUtensilCartQty > 0) {
				// remove from cart
					const result = await this.api(`/ordering/cart/${this.takeawayDiningUtensilRawId}`, 'delete', null);
				}

			} catch (err) {
				this.connectionErrorHanding(status);
				console.log("Error catch message:", err.message);
			} finally {
				this.loading = false;
			}
		},
	}
});